<template>

  <date-range-picker
    ref                     = "picker"
    :timePicker             = "timePicker"
    :timePicker24Hour       = "timePicker24Hour"
    :ranges                 = "ranges" 
    v-model                 = "dateRange"
    opens                   = "right"
    control-container-class = ""
    class                   = "col-md-12 pa-0 ma-0"

  >
    <!-- :locale-data="{format: 'DD-MM-YYYY HH:mm:ss' }"
    @update="updateValues" -->
    <!-- :date-format="dateFormat" -->
  <!-- form-control reportrange-text caption -->
  <!-- <div slot="header" slot-scope="header" class="slot">
    <h3>Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
  </div> -->
    <template v-slot:input = "picker" dark> <!--  style="width: 350px;"  -->
      <v-text-field
        outlined 
        dense
        :label = "$ml.get('date')"
        :value = "`${date_format(picker.startDate)} - ${date_format(picker.endDate)}`"
        hide-details
        style="width:390px;"

      >

      <!-- {{ picker.startDate | date }} - {{ picker.endDate | date }}" -->
       <!-- border:2px solid white;" -->
      </v-text-field>
    </template>
  </date-range-picker>

</template>
<style scoped>
/*@import "https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css";*/
  .slot {
    background-color: black/*#aaa*/;
    padding: 0.5rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .daterangepicker >>> dropdown-menu >>> ltr >>> show-calendar >>> show-ranges >>> opensright >>> linked{
    background-color: black;
  }
  .daterangepicker{
    background-color: #1e1e1e;
  }

  .text-black {
    color: black/*#000*/;
  }
</style>
<script>
  import DateRangePicker from 'vue2-daterange-picker'
  // import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import '@/components/css_data_range_picker.css'
  import moment from 'moment';
  export default{
    name: 'date_range',
    components:{
      DateRangePicker, 
      moment
    }, // components
    data: (vm) => ({
      dateRange: {
        startDate: null,
        endDate: null
        },
      picker: {},
      timePicker:true,
      timePicker24Hour:true,
      ranges:false,
      moment: moment,
    }), // data
    filters: {
      date(val) {
        return val ? val.toLocaleString() : '';
      }
    }, // filters
    created(){
      let f   = new Date();
      let day = f.getMonth() + 1 + "/" + f.getDate() + "/" +f.getFullYear();
      this.dateRange.startDate = [day,"00:00 AM"];//new 
      this.dateRange.endDate   = [day,"11:59 PM"];//new 
    }, // created

    watch:{
      dateRange: function(v){
        this.dates();
      }, // date Range
    }, // watch

    methods:{
      dates(){
        let date = []; 
        date.push(this.$momentz(new Date(this.dateRange.startDate)).utc().format('LLLL'));
        date.push(this.$momentz(new Date(this.dateRange.endDate)).utc().format('LLLL'));
        console.log(date, 'report dates');
        this.$emit('range', date);
      }, // dates

      date_format(val){
        return val ? val.toLocaleString() : '';
      }, // date_format

      dateFormat (classes, date) {
        if (!classes.disabled) {
          classes.disabled = date.getTime() < new Date()
        }
        return classes
      }, // dateFormat

    }, // methods
  };
</script>